import { DatePipe } from '@angular/common';
import { Signal } from '@angular/core';
import { ValidatorFn } from '@angular/forms';

export function minDateValidator(minimumDate: Signal<string | undefined>, datePipe?: DatePipe): ValidatorFn {
  return (control) => {
    const minimumDateValue = minimumDate();
    const value = control.value;

    if (!value || !minimumDateValue) return null;

    const inputDate = new Date(value);

    if (inputDate < new Date(minimumDateValue)) {
      const date = datePipe ? datePipe.transform(minimumDateValue, 'dd-MM-yyyy') : minimumDateValue;
      return { minimumDate: { requiredDate: date } };
    }
    return null;
  };
}
